import { useQuery } from '@tanstack/react-query';
import { messagesApi } from '../lib/api';

// Item del Feed AI: card "pulita" con arricchimenti AI.
export interface FeedItem {
  id: string;
  subject: string | null;
  from_name: string | null;
  from_email: string | null;
  date: string | null;
  ai_summary: string | null;
  ai_category: string | null;
  tags: { id: string; name: string; color: string; icon?: string | null; kind?: 'normal' | 'badge' }[];
  has_attachments: boolean;
  is_seen: boolean;
  snippet: string | null;
  is_spam: boolean;
}

// Hook Feed AI: carica i messaggi arricchiti degli ultimi `days` giorni.
// `enabled` permette il caricamento progressivo (7 -> 15 -> 31 su richiesta).
export function useFeed(days = 15, enabled = true) {
  return useQuery({
    queryKey: ['feed', days],
    enabled,
    queryFn: async () => {
      const res = await messagesApi.feed(days);
      // Difensivo sui vari possibili wrapper della risposta API
      const items = res?.items ?? res?.feed ?? res?.messages ?? [];
      return (items as FeedItem[]).map((it) => ({ ...it, tags: it.tags ?? [], is_spam: it.is_spam ?? false }));
    },
  });
}
